import { logger } from "../utils/utils";
import api from "./apis/api";

class CaneVarietyService {
  createCaneVariety(payload) {
    logger("CaneVarietyService", "createCaneVariety");
    return api.caneVariety.createCanVariety(payload);
  }

  updateCaneVariety(payload) {
    logger("CaneVarietyService", "updateCaneVariety");
    return api.caneVariety.updateCanVariety(
      payload?.canVarietyID,
      payload?.payload,
    );
  }

  getCaneVarietyList(payload) {
    logger("CaneVarietyService", "getCaneVarietyList");
    return api.caneVariety.getCanVarietyList(payload);
  }
  
  deleteCanVariety(canVarietyID){
    logger("CaneVarietyService", "deleteCanVariety");
    return api.caneVariety.deleteCanVariety(canVarietyID)

  }
}

export default new CaneVarietyService();
